import { render, staticRenderFns } from "./ResourcePage.vue?vue&type=template&id=0131573f"
import script from "./ResourcePage.vue?vue&type=script&lang=js"
export * from "./ResourcePage.vue?vue&type=script&lang=js"
import style0 from "./ResourcePage.vue?vue&type=style&index=0&id=0131573f&prod&deep=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports